import m from "mithril";

import { dayPath } from "../lib/routes";
import { dateAtMidnight, dayToWord } from "../lib/date_helpers";

type DayButtonParams = {
  attrs: {
    year: string,
    day: string,
  },
};

export class DayButton {
  year: number;
  day: number;

  constructor({ attrs }: DayButtonParams) {
    this.year = parseInt(attrs.year);
    this.day = parseInt(attrs.day);
  }

  midnight() {
    const day = this.day.toString().padStart(2, '0');
    return new Date(`${this.year}-12-${day}T00:00:00`);
  }

  visited() {
    return localStorage.getItem(`${this.year}-${this.day}`) || false;
  }

  visitable() {
    return (dateAtMidnight() >= this.midnight());
  }

  classes() {
    let classes = "button day-button ";

    classes += this.visited() ? "visited" : "not-visited";

    return classes
  }

  href() {
    if (this.visitable()) {
      return dayPath(this.year, this.day);
    }
  }

  view() {
    return <a
      href={this.href()}
      class={this.classes()}
      disabled={!this.visitable()}
    >
      {dayToWord(this.day)}
    </a>;
  }
}
